import { LocalizationFieldType } from '../../../graphql/generated/graphql.ts';
import type { Localization, SelectedParameter } from '../../../hooks/store/useAppStore';

export type LocalizationError = {
  key: string;
  msg: string;
  /**
   * `field` errors are rendered at the input itself, so repeating them in a summary only adds
   * noise; `analysis` errors have nowhere else to appear and are what a banner is for.
   */
  level: 'analysis' | 'field';
};

/**
 * Lives outside the chooser modal so that callers which only validate do not pull the modal - and
 * with it @dnd-kit - into the eager bundle.
 */
export const validateLocalizations = (
  selectedParams: SelectedParameter[],
  localizations: Localization[],
  /**
   * A Nachforderung reuses the initial order's Etikett, whose extra fields were captured when the
   * sample was taken. The chooser therefore shows them read-only instead of collecting them, and
   * RequestService skips validateFieldValues for the same reason - so demanding them here would
   * make every Nachforderung on a Material with a mandatory field unsubmittable.
   */
  isReorder = false,
  /** Name each analysis the way the screen names it, so a message can be acted on. */
  flipParamNames = false
) => {
  const errors: LocalizationError[] = [];
  selectedParams
    .filter(it => it.specimens.some(s => s.requiresLocalizations))
    .forEach(param => {
      param.specimens
        .filter(it => it.requiresLocalizations)
        .forEach(spec => {
          const own = localizations.filter(loc => loc.specimenId === spec.id && loc.paramId === param.id);
          if (!own.length) {
            const name = flipParamNames ? param.longName : param.shortName;
            errors.push({
              key: `${param.id}_${spec.id}`,
              msg: `${name}: mind. eine Lokalisation für ${spec.name}`,
              level: 'analysis',
            });
            return;
          }

          if (isReorder) {
            return;
          }

          own.forEach(loc => {
            spec.localizationFields.forEach(field => {
              const value = loc.fieldValues.find(v => v.label === field.label)?.value ?? '';
              const key = `${param.id}_${spec.id}_${loc.location}_${field.label}`;
              if (field.mandatory && !value.trim()) {
                errors.push({ key, msg: `${field.label} ist erforderlich`, level: 'field' });
              } else if (field.inputType === LocalizationFieldType.NUMBER && value.trim() && !Number.isFinite(Number(value))) {
                errors.push({ key, msg: `${field.label} muss eine Zahl sein`, level: 'field' });
              }
            });
          });
        });
    });
  return errors;
};
